import http from "../../Services/Auth/config/http-common";
import ICatTipoUnidades from "../../Interfaces/Catalogos/ICatTipoUnidades";
import IRespuesta from "../../Interfaces/Respuestas/IRespuesta";

class CatTipoUnidadDataService {
  Get() {
    return http.get<ICatTipoUnidades[]>("Catalogos/CatTipoUnidad/Get");
  }
  Append(data: ICatTipoUnidades) {
    return http.post<ICatTipoUnidades>(`Catalogos/CatTipoUnidad/Append`,data);
  }
  Delete(id: number) {
    return http.delete<IRespuesta>(`Catalogos/CatTipoUnidad/Delete/${id}`);
  }
}
export default new CatTipoUnidadDataService();